import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useBackground } from '../../context/BackgroundContext';
// colors import removed - not used

const BackgroundContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
`;

const OrbBase = styled(motion.div)`
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.6;
  will-change: transform, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;

  @media (max-width: 768px) {
    filter: blur(40px);
    opacity: 0.5;
  }
`;

const PrimaryOrb = styled(OrbBase)`
  width: 60vw;
  height: 60vw;
  top: -20%;
  left: -20%;

  @media (max-width: 768px) {
    width: 90vw;
    height: 90vw;
    top: -10%;
    left: -20%;
  }
`;

const SecondaryOrb = styled(OrbBase)`
  width: 50vw;
  height: 50vw;
  bottom: -20%;
  right: -20%;

  @media (max-width: 768px) {
    width: 80vw;
    height: 80vw;
    bottom: 10%;
    right: -30%;
  }
`;

const TertiaryOrb = styled(OrbBase)`
  width: 40vw;
  height: 40vw;
  top: 30%;
  left: 30%;
  opacity: 0.4;

  @media (max-width: 768px) {
    width: 70vw;
    height: 70vw;
    top: 40%;
    left: 10%;
    opacity: 0.3;
  }
`;

const AnimatedBackground = () => {
  const { currentTheme } = useBackground();

  return (
    <BackgroundContainer
      animate={{ backgroundColor: currentTheme.background }}
      transition={{ duration: 0.8, ease: "easeInOut" }} // Geçiş süresi biraz hızlandırıldı
    >
      <AnimatePresence mode="wait">
        {/* Birinci Orb */}
        <PrimaryOrb
          key={`orb1-${currentTheme.orb1}`} // Renk değişince yeniden render et
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: 0.6,
            scale: 1,
            x: [0, 100, 0],
            y: [0, 50, 0],
            background: `radial-gradient(circle, ${currentTheme.orb1} 0%, rgba(0,0,0,0) 70%)`
          }}
          exit={{ opacity: 0, scale: 1.2, duration: 0.5 }}
          transition={{
            opacity: { duration: 1 },
            scale: { duration: 1 },
            x: { duration: 20, repeat: Infinity, ease: "easeInOut" },
            y: { duration: 20, repeat: Infinity, ease: "easeInOut" }
          }}
        />

        {/* İkinci Orb */}
        <SecondaryOrb
          key={`orb2-${currentTheme.orb2}`}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: 0.6,
            scale: 1,
            x: [0, -100, 0],
            y: [0, -50, 0],
            background: `radial-gradient(circle, ${currentTheme.orb2} 0%, rgba(0,0,0,0) 70%)`
          }}
          exit={{ opacity: 0, scale: 1.2, duration: 0.5 }}
          transition={{
            opacity: { duration: 1 },
            scale: { duration: 1 },
            x: { duration: 25, repeat: Infinity, ease: "easeInOut", delay: 2 },
            y: { duration: 25, repeat: Infinity, ease: "easeInOut", delay: 2 }
          }}
        />

        {/* Üçüncü Orb */}
        <TertiaryOrb
          key={`orb3-${currentTheme.orb3}`}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: 0.4,
            scale: 1,
            x: [0, -50, 50, 0],
            y: [0, 50, -50, 0],
            background: `radial-gradient(circle, ${currentTheme.orb3} 0%, rgba(0,0,0,0) 70%)`
          }}
          exit={{ opacity: 0, scale: 1.2, duration: 0.5 }}
          transition={{
            opacity: { duration: 1 },
            scale: { duration: 1 },
            x: { duration: 30, repeat: Infinity, ease: "easeInOut", delay: 5 },
            y: { duration: 30, repeat: Infinity, ease: "easeInOut", delay: 5 }
          }}
        />
      </AnimatePresence>
    </BackgroundContainer>
  );
};

export default AnimatedBackground;
